// extracted by mini-css-extract-plugin
var _1 = "WalletFormStyle-module__disabled-select___k6b8k";
var _2 = "WalletFormStyle-module__disabled-select___k6b8k";
var _3 = "WalletFormStyle-module__headline___rLDrd";
var _4 = "WalletFormStyle-module__info___Vlc0A";
var _5 = "WalletFormStyle-module__select___uAoFf";
var _6 = "WalletFormStyle-module__wallet-form___fbZX6";
var _7 = "WalletFormStyle-module__wallet-form___fbZX6";
export { _1 as "disabled-select", _2 as "disabledSelect", _3 as "headline", _4 as "info", _5 as "select", _6 as "wallet-form", _7 as "walletForm" }
